import Vue from 'vue'
import Router from 'vue-router'

// VIEWS
import Home from '../views/Home'
import UserTypeChoice from '../views/Survey/UserTypeChoice'
import TeacherDetails from '../views/Survey/TeacherDetails'
import ParentDetails from '../views/Survey/ParentDetails'
import Start from '../views/Start'
import Students from '../views/Students'
import Intro from '../views/introductions/Intro'
import Reception from '../views/rooms/Reception'
import CommunualArea from '../views/rooms/CommunualArea'
import Bedroom from '../views/rooms/Bedroom'
import Kitchen from '../views/rooms/Kitchen'
import Question from '../views/Question'
import Feedback from '../views/Feedback'
import UserFeedback1 from '../views/Survey/UserFeedback1'
import UserFeedback2 from '../views/Survey/UserFeedback2'
import UserFeedback3 from '../views/Survey/UserFeedback3'
import UserFeedback4 from '../views/Survey/UserFeedback4'
import Result from '../views/Result'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { pageCssClass: 'homePage' }
      // You can specify the page CSS Class for this route via the meta.pageCssClass property
      // meta: { pageCssClass: 'homePage' }
    },
    {
      path: '/who',
      name: 'who',
      component: UserTypeChoice,
      meta: { pageCssClass: 'whoPage' }
    },
    {
      path: '/teacher',
      name: 'teacher',
      component: TeacherDetails,
      meta: { pageCssClass: 'teacherRegPage' }
    },
    {
      path: '/parent',
      name: 'parent',
      component: ParentDetails,
      meta: { pageCssClass: 'parentRegPage' }
    },
    {
      path: '/start',
      name: 'start',
      component: Start,
      meta: { pageCssClass: 'startPage' }
    },
    {
      path: '/students',
      name: 'students',
      component: Students,
      meta: { pageCssClass: 'studentStartPage' }
    },
    {
      path: '/intro/:id',
      name: 'intro',
      component: Intro,
      meta: { pageCssClass: 'introPage' }
    },
    {
      path: '/reception',
      name: 'reception',
      component: Reception,
      meta: { pageCssClass: 'receptionRoomPage' }
    },
    {
      path: '/communual-area',
      name: 'communual-area',
      component: CommunualArea,
      meta: { pageCssClass: 'commonRoomPage' }
    },
    {
      path: '/bedroom',
      name: 'bedroom',
      component: Bedroom,
      meta: { pageCssClass: 'bedroomRoomPage' }
    },
    {
      path: '/kitchen',
      name: 'kitchen',
      component: Kitchen,
      meta: { pageCssClass: 'kitchenRoomPage' }
    },
    {
      path: '/:room/q/:question',
      name: 'question',
      component: Question,
      meta: { pageCssClass: 'questionPage' }
    },
    {
      path: '/:room/q/:question/f/:answer',
      name: 'feedback',
      component: Feedback,
      meta: { pageCssClass: 'feedbackPage' }
    },
    {
      path: '/survey',
      name: 'survey',
      component: UserFeedback1,
      meta: { pageCssClass: 'survey1Page' }
    },
    {
      path: '/survey1',
      name: 'survey1',
      component: UserFeedback2,
      meta: { pageCssClass: 'survey2Page' }
    },
    {
      path: '/survey2',
      name: 'survey2',
      component: UserFeedback3,
      meta: { pageCssClass: 'survey3Page' }
    },
    {
      path: '/survey3',
      name: 'survey3',
      component: UserFeedback4,
      meta: { pageCssClass: 'survey4Page' }
    },
    {
      path: '/result/:id',
      name: 'result',
      component: Result,
      meta: { pageCssClass: 'finalResultsPage' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js